import { Box, Divider, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next'; // Import useTranslation

// Car FAQ section
const CarQuestionsSection = ({ questions }) => {
  const theme = useTheme();
  const { t } = useTranslation("carDetails");

  const createQuestionPairs = () => {
    const pairs = [];
    for (let i = 0; i < questions.length; i += 2) {
      pairs.push(questions.slice(i, i + 2));
    }
    return pairs;
  };

  return (
    <Box
      sx={{
        mb: 4,
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#fafafa',
        borderRadius: '9px',
        padding: '1rem',
        border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : '#e0e0e0'}`,
      }}
    >
      <Typography variant="h6" fontWeight={700} color={theme.palette.primary.main} sx={{ mb: 1.5, px: 0.5 }}>
        {/* Static String 1: Header */}
        {t("Vehicle Questions & Answers")}
      </Typography>

      {createQuestionPairs().map((pair, pairIndex) => (
        <Grid container spacing={1.5} width={'100%'} key={pairIndex} sx={{ mb: 1.5 }}>
          {pair.map((question, index) => (
            <Grid item size={{ xs: 12, md: 6 }} key={`${pairIndex}-${index}`}>
              <Box
                sx={{
                  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#fff',
                  padding: '0.5rem 0.875rem',
                  borderRadius: '6px',
                  border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#e8e8e8'}`,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.2rem',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    boxShadow:
                      theme.palette.mode === 'dark' ? '0 2px 8px rgba(0, 0, 0, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.08)',
                    transform: 'translateY(-1px)',
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: `${16 / 16}rem`,
                    fontWeight: 600,
                    color: theme.palette.primary.main,
                    letterSpacing: '0.5px',
                  }}
                >
                  {t(question.question)} 
                </Typography>
                <Divider sx={{ my: 0 }} />
                <Typography
                  sx={{
                    fontSize: `${16 / 16}rem`,
                    fontWeight: 400,
                    color: theme.palette.mode === 'dark' ? '#b0b0b0' : '#555',
                    lineHeight: 1.4,
                  }}
                >
                  {question.answer || (
                    <Typography
                      component="span"
                      sx={{
                        fontSize: '0.875rem',
                        fontStyle: 'italic',
                        color: theme.palette.mode === 'dark' ? '#666' : '#999',
                      }}
                    >
                      {/* Static String 2: Fallback text */}
                      {t("N/A")}
                    </Typography>
                  )}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      ))}
    </Box>
  );
};

export default CarQuestionsSection;

CarQuestionsSection.propTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      answer: PropTypes.string,
    })
  ),
};